<template>
  <transition name="about-modal">
    <div v-if="open" class="about-modal">
      <button class="about-modal__backdrop" type="button" @click="$emit('close')"></button>

      <section class="about-modal__panel">
        <div class="about-modal__top">
          <div>
            <p class="section-kicker">About me</p>
            <h2>Krilin Schmid</h2>
            <p>
              Informatiker Betriebsinformatik EFZ und Foto- & Videograf mit Leidenschaft für echte Momente,
              klare Bilder und Geschichten mit Charakter.
            </p>
          </div>

          <button class="about-modal__close" type="button" @click="$emit('close')">
            ×
          </button>
        </div>

        

        <div class="about-tabs">
          <button
            type="button"
            :class="{ active: selectedCategory === 'business' }"
            @click="selectedCategory = 'business'"
          >
            Beruflich
          </button>

          <button
            type="button"
            :class="{ active: selectedCategory === 'private' }"
            @click="selectedCategory = 'private'"
          >
            Privat & Hobbys
          </button>
        </div>

        <div class="about-timeline">
          <article
            v-for="(item, index) in filteredTimeline"
            :key="`${item.title}-${index}`"
            class="about-timeline__item"
          >
            <div class="about-timeline__date">
              {{ item.date }}
            </div>

            <div class="about-timeline__card">
              <p v-if="item.label" class="about-timeline__label">
                {{ item.label }}
              </p>

              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>

              <button
                v-if="item.achievements?.length || item.subItems?.length"
                type="button"
                class="about-timeline__toggle"
                @click="toggleItem(index)"
              >
                {{ expandedItems[index] ? 'Weniger anzeigen' : 'Mehr anzeigen' }}
              </button>

              <transition name="about-details">
                <div v-if="expandedItems[index]" class="about-timeline__details">
                  <ul v-if="item.achievements?.length">
                    <li v-for="achievement in item.achievements" :key="achievement">
                      {{ achievement }}
                    </li>
                  </ul>

                  <div
                    v-for="sub in item.subItems"
                    :key="sub.title"
                    class="about-timeline__sub"
                  >
                    <h4>{{ sub.title }}</h4>
                    <ul>
                      <li v-for="achievement in sub.achievements" :key="achievement">
                        {{ achievement }}
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
          </article>
        </div>
      </section>
    </div>
  </transition>
</template>

<script setup>
import { computed, ref, defineProps, defineEmits } from 'vue'


defineProps({
  open: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['close'])

const selectedCategory = ref('business')
const expandedItems = ref({})

function toggleItem(index) {
  expandedItems.value[index] = !expandedItems.value[index]
}

const timeline = [
    {
    category: 'business',
    date: 'März 2026 - heute',
    title: 'Marketingassistent @ Interhockey',
    description:
        'Nach Abschluss meiner obligatorischen Dienstpflicht hat mich mein Weg zurück zur Interhockey geführt. Gleiche Firma, neue Aufgaben mit Fokus auf Markenauftritt, Webshop, Content und Design.',
    achievements: [
        'Corporate Identity: Weiterentwicklung von CI/CD-Richtlinien für einen konsistenten Markenauftritt über alle Kanäle.',
        'Webshop-Management: Pflege, Optimierung, Artikelerfassung und Strukturierung von Produktdaten.',
        'Content-Produktion: Erstellung und Bearbeitung von Produktbildern inklusive eigener Fotografie bei fehlendem Bildmaterial.',
        'Marketingkampagnen: Planung, Konzeption und Umsetzung von Newsletter- und Social-Media-Kampagnen.',
        'Grafikdesign: Erstellung von Werbemitteln für Print und Digital im Einklang mit der Markenidentität.',
        'Produktdesign: Gestaltung von Textilkollektionen und Merchandisingprodukten für Vereine.',
        'Publikationen: Gestaltung, Erstellung und Aktualisierung von Produktkatalogen und bestehenden Unterlagen.',
    ],
    },
  {
    category: 'business',
    date: 'Juli 2025 - März 2026',
    title: 'Zivildienst IT in der Stiftung Lerchenbühl',
    description:
      'Direkt im Anschluss an meinen ersten Einsatz habe ich einen weiteren Zivildienst-Einsatz gemacht, um danach wieder voll auf meinen beruflichen Weg fokussieren zu können.',
    achievements: [
      'Unterstützung der Lehrperson im Klassenzimmer und in der Berufsvorbereitung',
      '1st und 2nd Level Support der Mitarbeiter/innen',
      'Projektübernahme von diversen IT-Projekten',
    ],
  },
  {
    category: 'business',
    date: 'Januar 2025 - Juni 2025',
    title: 'Zivildienst an den Schulen der Gemeinde Lützelflüh',
    description:
      'Als Zivildienstleistender unterstützte ich die Schule im Alltag, in der Tagesstruktur und bei administrativen Aufgaben.',
    achievements: [
      'Unterstützung der Lehrperson im Klassenzimmer',
      'Begleitperson in der Tagesstruktur',
      'Administrative Aufgaben in der Schule',
    ],
  },
  {
    category: 'business',
    date: 'August 2023 - Dezember 2024',
    title: 'Marketingassistent @ Interhockey',
    description:
      'Zuständig für Merchandising-Management, Webseiten, Webshops, Content und digitale Kommunikation rund um Sportclubs und Unternehmen.',
    achievements: [
      'Sortimentmanagement für Merchandising des SC Bern und HC Ajoie',
      'Leitung von Merchandisingprojekten für Sportclubs und Unternehmen',
      'Pflege und Aktualisierung von Webseiten und Webshops',
      'Erstellung von Anzeigen, Newslettern und Social-Media-Beiträgen',
      'Gestaltung von Produktlayouts',
    ],
  },
  {
    category: 'business',
    date: 'Januar 2023 - Juli 2023',
    title: 'Auftragsbearbeitung @ Interhockey',
    description:
      'Mitarbeit in der Auftragsbearbeitung, Kundenpflege, Webshop-Support und interner IT-Unterstützung.',
    achievements: [
      'Kontrolle der Kassenabschlüsse',
      'Bearbeitung von Kundenbestellungen',
      'Erfassung und Wartung von Kundenkonten',
      'Unterstützung bei Webshop- und IT-Themen',
    ],
  },
  {
    category: 'business',
    date: 'August 2022 - Dezember 2022',
    title: 'Berufliche Auszeit',
    description:
      'Reise nach Hawaii und New York — eine prägende Zeit mit neuen Eindrücken, viel Inspiration und persönlichem Wachstum.',
    achievements: [],
  },
  {
    category: 'business',
    date: 'August 2018 - Juli 2022',
    title: 'Lehre Informatiker Betriebsinformatik EFZ @ Swisscom',
    label: 'Swisscom Lehre',
    description:
      'Während meiner Ausbildung durchlief ich verschiedene technische und kreative Abteilungen bei Swisscom.',
    subItems: [
      {
        title: 'Fullstack Developer @ AppsTeam',
        achievements: [
          'Frontend- und Backend-Weiterentwicklung',
          'Datenverwaltung mit TypeOrm/MySQL',
          'Onboarding von Telekommunikationsservices',
        ],
      },
      {
        title: 'Mac Engineering Service @ Swisscom',
        achievements: [
          'Support von Mac-Benutzern',
          'Automatisierung mit Bash',
          'Weiterentwicklung von Managed Mac Services',
        ],
      },
      {
        title: 'Frontend Developer @ Traffy',
        achievements: [
          'Frontendentwicklung mit Vue.js',
          'Erste Erfahrungen mit Git',
          'SCRUM kennengelernt',
        ],
      },
    ],
  },
  {
    category: 'private',
    date: 'Seit 2022',
    title: 'Foto- & Videograf',
    description:
      'In meiner Freizeit widme ich mich mit Leidenschaft der Fotografie und Videografie — von Sport über Street bis zu Portraits, Events und Automotive.',
    achievements: [
      'Aufbau einer professionellen Kameraausrüstung',
      'Erfahrung mit Adobe Lightroom & DaVinci Resolve',
      'Präsentation meiner Arbeiten über Instagram und eigene Website',
      'Sportfotografie bei Heimspielen und Events',
    ],
  },
  {
    category: 'private',
    date: 'Seit 2017',
    title: 'Aktivmitglied im Turnverein Bärau',
    description:
      'Vielseitig sportlich aktiv mit Fokus auf Leichtathletik, Unihockey und Vereinsleben.',
    achievements: [
      'Co-Leitung des Unihockeyteams',
      'Trainingsorganisation und Mitgliedergewinnung',
      'Pflege der Vereinswebseite und des Instagram-Kanals',
    ],
  },
  {
    category: 'private',
    date: 'Seit 2010',
    title: 'Leidenschaftlicher Eishockeyspieler',
    description:
      'Eishockey begleitet mich seit meiner Kindheit — vom Nachwuchsspieler bis zum heutigen Plauschhockey.',
    achievements: [
      'Juniorenzeit bei den SCL Young Tigers und HC Huskys Oberlangenegg',
      'Heute aktiv als Plauschhockeyspieler',
    ],
  },
  {
    category: 'private',
    date: 'Seit Juni 2023',
    title: 'Jugendsportleiter 6.–9. Klasse',
    description:
      'Ich unterstütze Jugendliche im Sport und begleite sie bei Trainings, Wettkämpfen und Vereinsanlässen.',
    achievements: [
      'Leitung und Mitgestaltung von Trainings',
      'Betreuung bei Wettkämpfen',
      'Förderung von Teamgeist und Bewegung',
    ],
  },
]

const filteredTimeline = computed(() => {
  return timeline.filter((item) => item.category === selectedCategory.value)
})
</script>

<style scoped>
.about-modal {
  --background: #2f2e2e;
  --secondary-background: #454545;
  --accent: #8b7054;
  --accent-secondary: #6c553d;
  --text-primary: #d6d1ce;
  --text-secondary: #e6e1de;

  position: fixed;
  inset: 0;
  z-index: 500;
  display: grid;
  place-items: center;
  padding: 24px;
  color: var(--text-primary);
  font-family: 'Halenoir', sans-serif;
}

.about-modal__backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(12, 12, 12, 0.72);
  backdrop-filter: blur(18px);
  cursor: pointer;
}

.about-modal__panel {
  position: relative;
  z-index: 1;
  width: min(100%, 1120px);
  max-height: min(88vh, 980px);
  overflow: auto;
  border: 1px solid rgba(214, 209, 206, 0.12);
  border-radius: 36px;
  background:
    radial-gradient(circle at 20% 0%, rgba(139, 112, 84, 0.18), transparent 34%),
    linear-gradient(180deg, #2f2e2e 0%, #373636 100%);
  box-shadow: 0 30px 120px rgba(0, 0, 0, 0.42);
  padding: 42px;
}

.about-modal__top {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 32px;
  align-items: start;
}

.section-kicker {
  color: var(--accent);
  font-size: 0.82rem;
  font-weight: 900;
  letter-spacing: 0.28em;
  margin: 0 0 16px;
  text-transform: uppercase;
}

.about-modal__top h2 {
  color: var(--text-secondary);
  font-size: clamp(3.5rem, 7vw, 7.5rem);
  font-weight: 900;
  letter-spacing: -0.07em;
  line-height: 0.9;
  margin: 0;
}

.about-modal__top p:not(.section-kicker) {
  max-width: 720px;
  color: rgba(214, 209, 206, 0.82);
  font-size: 1.08rem;
  line-height: 1.75;
  margin: 24px 0 0;
}

.about-modal__close {
  width: 48px;
  height: 48px;
  border: 1px solid rgba(214, 209, 206, 0.14);
  border-radius: 999px;
  background: rgba(230, 225, 222, 0.08);
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 2rem;
  line-height: 1;
  transition:
    transform 180ms ease,
    background 180ms ease;
}

.about-modal__close:hover {
  transform: rotate(8deg) scale(1.04);
  background: var(--accent);
  color: var(--background);
}

.about-modal__intro {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 32px;
  align-items: center;
  margin-top: 42px;
}

.about-modal__image {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border: 1px solid rgba(214, 209, 206, 0.12);
  border-radius: 32px;
  filter: saturate(0.92) contrast(1.02);
}

.about-modal__intro-text {
  border: 1px solid rgba(214, 209, 206, 0.12);
  border-radius: 32px;
  background: rgba(69, 69, 69, 0.38);
  padding: 32px;
}

.about-modal__intro-text h3 {
  color: var(--text-secondary);
  font-size: clamp(2rem, 3.2vw, 3.4rem);
  font-weight: 900;
  letter-spacing: -0.06em;
  line-height: 1;
  margin: 0;
}

.about-modal__intro-text p {
  color: rgba(214, 209, 206, 0.84);
  font-size: 1.05rem;
  line-height: 1.75;
  margin: 22px 0 0;
}

.about-tabs {
  display: inline-flex;
  gap: 6px;
  border: 1px solid rgba(214, 209, 206, 0.1);
  border-radius: 999px;
  background: rgba(69, 69, 69, 0.36);
  margin-top: 42px;
  padding: 6px;
}

.about-tabs button {
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: rgba(214, 209, 206, 0.72);
  cursor: pointer;
  font-family: inherit;
  font-weight: 900;
  padding: 13px 20px;
  transition:
    background 180ms ease,
    color 180ms ease,
    transform 180ms ease;
}

.about-tabs button:hover {
  transform: translateY(-1px);
  color: var(--text-secondary);
}

.about-tabs button.active {
  background: var(--accent);
  color: var(--background);
}

.about-timeline {
  display: grid;
  gap: 22px;
  margin-top: 34px;
}

.about-timeline__item {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 24px;
}

.about-timeline__date {
  color: var(--accent);
  font-size: 0.86rem;
  font-weight: 900;
  letter-spacing: 0.12em;
  line-height: 1.5;
  padding-top: 28px;
  text-transform: uppercase;
}

.about-timeline__card {
  border: 1px solid rgba(214, 209, 206, 0.12);
  border-radius: 28px;
  background: rgba(69, 69, 69, 0.38);
  padding: 28px;
  transition:
    transform 220ms ease,
    border-color 220ms ease,
    background 220ms ease;
}

.about-timeline__card:hover {
  transform: translateY(-3px);
  border-color: rgba(139, 112, 84, 0.48);
  background: rgba(69, 69, 69, 0.5);
}

.about-timeline__label {
  display: inline-flex;
  border-radius: 999px;
  background: rgba(139, 112, 84, 0.18);
  color: var(--accent);
  font-size: 0.72rem;
  font-weight: 900;
  letter-spacing: 0.2em;
  margin: 0 0 16px;
  padding: 8px 12px;
  text-transform: uppercase;
}

.about-timeline__card h3 {
  color: var(--text-secondary);
  font-size: clamp(1.35rem, 2vw, 2.1rem);
  font-weight: 900;
  letter-spacing: -0.04em;
  line-height: 1.05;
  margin: 0;
}

.about-timeline__card p {
  color: rgba(214, 209, 206, 0.82);
  font-size: 1rem;
  line-height: 1.7;
  margin: 14px 0 0;
}

.about-timeline__toggle {
  border: 1px solid rgba(214, 209, 206, 0.14);
  border-radius: 999px;
  background: rgba(230, 225, 222, 0.06);
  color: var(--text-secondary);
  cursor: pointer;
  font-family: inherit;
  font-weight: 900;
  margin-top: 20px;
  padding: 11px 16px;
  transition:
    background 180ms ease,
    color 180ms ease,
    transform 180ms ease;
}

.about-timeline__toggle:hover {
  transform: translateY(-1px);
  background: var(--accent);
  color: var(--background);
}

.about-timeline__details {
  margin-top: 22px;
}

.about-timeline__details ul {
  display: grid;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.about-timeline__details li {
  position: relative;
  color: rgba(214, 209, 206, 0.86);
  line-height: 1.6;
  padding-left: 22px;
}

.about-timeline__details li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.72em;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--accent);
}

.about-timeline__sub {
  border-left: 2px solid rgba(139, 112, 84, 0.52);
  margin-top: 20px;
  padding-left: 18px;
}

.about-timeline__sub h4 {
  color: var(--text-secondary);
  font-size: 1.08rem;
  margin: 0 0 12px;
}

.about-modal-enter-active,
.about-modal-leave-active {
  transition: opacity 240ms ease;
}

.about-modal-enter-active .about-modal__panel,
.about-modal-leave-active .about-modal__panel {
  transition:
    opacity 260ms ease,
    transform 260ms ease;
}

.about-modal-enter-from,
.about-modal-leave-to {
  opacity: 0;
}

.about-modal-enter-from .about-modal__panel,
.about-modal-leave-to .about-modal__panel {
  opacity: 0;
  transform: translateY(18px) scale(0.985);
}

.about-details-enter-active,
.about-details-leave-active {
  transition:
    opacity 220ms ease,
    transform 220ms ease;
}

.about-details-enter-from,
.about-details-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

@media (max-width: 820px) {
  .about-modal {
    padding: 12px;
  }

  .about-modal__panel {
    max-height: 92vh;
    border-radius: 28px;
    padding: 26px;
  }

  .about-modal__top,
  .about-modal__intro,
  .about-timeline__item {
    grid-template-columns: 1fr;
  }

  .about-modal__top h2 {
    font-size: clamp(3rem, 15vw, 5rem);
  }

  .about-timeline__date {
    padding-top: 0;
  }
}
</style>